import React from "react";
//Kendo Imports
import {
    Chart,
    ChartArea,
    ChartTitle,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisTitle,
    ChartCategoryAxisItem,
    ChartLegend,
    ChartValueAxis,
    ChartValueAxisItem,
    ChartSeriesLabels,
    ChartSeriesItemTooltip,
    ChartTooltip
} from "@progress/kendo-react-charts";

const PoleRestorationChart = ({ steelSizeCat, steelSizeCount, noRestoreResonCat, noRestoreReasonCount, }) => {
    const SteelSizeChart = () => {
        return (
            <Chart>
                <ChartArea height={300} />
                <ChartCategoryAxis>
                    <ChartCategoryAxisItem categories={steelSizeCat}>
                        <ChartCategoryAxisTitle text="Steel Size" />
                    </ChartCategoryAxisItem>
                </ChartCategoryAxis>
                <ChartSeries>
                    <ChartSeriesItem
                        type="bar"
                        data={steelSizeCount}
                        color="#4285f4"
                        tooltip={{ visible: true }}
                    />
                </ChartSeries>
            </Chart>    
        )
    }

    const NoRestoreReasonChart = () => {
        return (
            <Chart>
                <ChartArea height={300} />
                <ChartCategoryAxis>
                    <ChartCategoryAxisItem categories={noRestoreResonCat}>
                        <ChartCategoryAxisTitle text="No Restore Reason" />
                    </ChartCategoryAxisItem>
                </ChartCategoryAxis>
                <ChartSeries>
                    <ChartSeriesItem
                        type="bar"
                        data={noRestoreReasonCount}
                        color="#4285f4"
                        tooltip={{ visible: true }}
                    />
                </ChartSeries>
            </Chart>
        )
    }

    return (
        <div className="rs-restore-wrapper">
            <div className="rs-chart-section">
                <p className="pulse-chart-title">Restored (Steel Size)</p>
                <div className="pulse-chart-container">
                    <SteelSizeChart />
                </div>
            </div>
            <div className="rs-chart-section">
                <p className="pulse-chart-title">Not Restored (No Restored Reason)</p>
                <div className="pulse-chart-container">
                    <NoRestoreReasonChart />
                </div>
            </div>
        </div>
    );
}

export default PoleRestorationChart;